module.exports = __webpack_public_path__ + "media/images/official/special_migration_11-e5c7b00c9947a2ace15bc52b7b240eb7.jpg";